module.exports = __webpack_public_path__ + "img/paleo.0618d25a.jpg";